import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    // we init with resources
    resources: {
      en: {
        translations: {
          "General": "General",
          "Dashboards": "Dashboards",
          "Default": "Default",
          "Project": "Project",
          "Online Course":"Online Course",
          "Ecommerce": "Ecommerce",
          "Education": "Education",
          "Widgets": "Widgets",
          "Chart": "Chart",
          "Applications": "Applications",
          "Project List": "Project List",
          "Create New": "Create New",
          "File Manager": "File Manager",
          "Add Product": "Add Product",
          "Product": "Product",
          "Product Page": "Product Page",
          "Product List": "Product List",
          "Payment Details": "Payment Details",
          "Order History": "Order History",
          "Invoice": "Invoice",
          "Invoice-1": "Invoice-1",
          "Invoice-2": "Invoice-2",
          "Invoice-3": "Invoice-3",
          "Invoice-4": "Invoice-4",
          "Invoice-5": "Invoice-5",
          "Invoice-6": "Invoice-6",
          "Cart": "Cart",
          "Wishlist": "Wishlist",
          "Checkout": "Checkout",
          "Pricing": "Pricing",
          "Chat": "Chat",
          "Users": "Users",
          "Letter Box": "Letter Box",
          "Private Chat": "Private Chat",
          "Group Chat": "Group Chat",
          "User Profile": "User Profile",
          "User Edit": "User Edit",
          "User Cards": "User Cards",
          "Bookmarks": "Bookmarks",
          "Contacts": "Contacts",
          "Task": "Task",
          "Calendar": "Calendar",
          "Social App": "Social App",
          "Todo": "Todo",
          "Search Result": "Search Result",
          "Form Validation": "Form Validation",
          "Base Inputs": "Base Inputs",
          "Checkbox & Radio": "Checkbox & Radio",
          "Input Groups": "Input Groups",
          "Input Mask": "Input Mask",
          "Mega Option": "Mega Option",
          "Datepicker": "Datepicker",
          "Touchspin": "Touchspin",
          "Switch": "Switch",
          "Forms": "Forms",
          "Form Controls": "Form Controls",
          "Forms & Table": "Forms & Table",
          "Typeahead": "Typeahead",
          "Clipboard": "Clipboard",
          "Form Widget": "Form Widget",
          "Form Wizard 1": "Form Wizard 1",
          "Form Wizard 2": "Form Wizard 2",
          "Two Factor": "Two Factor",
          "Form Layout": "Form Layout",
          "Table": "Table",
          "Reactstrap Tables": "Reactstrap Tables",
          "Basic Tables": "Basic Tables",
          "Table Components": "Table Components",
          "Data Tables": "Data Tables",
          "Basic Init": "Basic Init",
          "Advance Init": "Advance Init",
          "API": "API",
          "Data Source": "Data Source",
          "Components": "Components",
          "Typography": "Typography",
          "Avatars": "Avatars",
          "Helper Classes": "Helper Classes",
          "Grid": "Grid",
          "Tag & Pills": "Tag & Pills",
          "Progress": "Progress",
          "Modal": "Modal",
          "Alert": "Alert",
          "Popover": "Popover",
          "Tooltip": "Tooltip",
          "Dropdown": "Dropdown",
          "Accordion": "Accordion",
          "Tabs": "Tabs",
          "Lists": "Lists",
          "Bonus-Ui": "Bonus-Ui",
          "Scrollable": "Scrollable",
          "Tree View": "Tree View",
          "Toasts": "Toasts",
          "Rating": "Rating",
          "Dropzone": "Dropzone",
          "Tour": "Tour",
          "SweetAlert2": "SweetAlert2",
          "Carousel": "Carousel",
          "Ribbons": "Ribbons",
          "Pagination": "Pagination",
          "Breadcrumb": "Breadcrumb",
          "Range Slider": "Range Slider",
          "Image Cropper": "Image Cropper",
          "Basic Card": "Basic Card",
          "Creative Card": "Creative Card",
          "Timeline": "Timeline",
          "Icons": "Icons",
          "Flag Icon": "Flag Icon",
          "Fontawesome Icon": "Fontawesome Icon",
          "Ico Icon": "Ico Icon",
          "Themify Icon": "Themify Icon",
          "Feather Icon": "Feather Icon",
          "Weather Icon": "Weather Icon",
          "Buttons": "Buttons",
          "Default Style": "Default Style",
          "Flat Style": "Flat Style",
          "Edge Style": "Edge Style",
          "Raised Style": "Raised Style",
          "Button Group": "Button Group",
          "Charts": "Charts",
          "Apex Chart": "Apex Chart",
          "Google Chart": "Google Chart",
          "Chart JS Chart": "Chart JS Chart",
          "Ui-Kits": "Ui-Kits",
          "Pages": "Pages",
          "Sample Page": "Sample Page",
          "Others": "Others",
          "Error Pages": "Error Pages",
          "Error 400": "Error 400",
          "Error 401": "Error 401",
          "Error 403": "Error 403",
          "Error 404": "Error 404",
          "Error 500": "Error 500",
          "Error 503": "Error 503",
          "Login Simple": "Login Simple",
          "Login With Bg Image": "Login With Bg Image",
          "Login With Image Two": "Login With Image Two",
          "Login With Validation": "Login With Validation",
          "Login With Tooltip": "Login With Tooltip",
          "Login With Sweetalert": "Login With Sweetalert",
          "Register Simple": "Register Simple",
          "Register With Bg Image": "Register With Bg Image",
          "Register With Bg Two": "Register With Bg Two",
          "Register Wizard": "Register Wizard",
          "Unlock User": "Unlock User",
          "Forget Password": "Forget Password",
          "Reset Password": "Reset Password",
          "Maintenance": "Maintenance",
          "Coming Simple": "Coming Simple",
          "Coming With Bg Video": "Coming With Bg Video",
          "Coming With Bg Image": "Coming With Bg Image",
          "Miscellaneous": "Miscellaneous",
          "Gallery": "Gallery",
          "Gallery Grids": "Gallery Grids",
          "Gallery Grid Desc": "Gallery Grid Desc",
          "Masonry Gallery": "Masonry Gallery",
          "Masonry With Desc": "Masonry With Desc",
          "Hover Effect": "Hover Effect",
          "Blog": "Blog",
          "Blog Details": "Blog Details",
          "Blog Single": "Blog Single",
          "Add Post": "Add Post",
          "FAQ": "FAQ",
          "Job Search": "Job Search",
          "Cards View": "Cards View",
          "List View": "List View",
          "Job Detail": "Job Detail",
          "Apply": "Apply",
          "Learning": "Learning",
          "Learning List": "Learning List",
          "Detailed Course": "Detailed Course",
          "Map": "Map",
          "Google Map": "Google Map",
          "Leaflet Map": "Leaflet Map",
          "Editor": "Editor",
          "CK Editor": "CK Editor",
          "MDE Editor": "MDE Editor",
          "ACE Editor": "ACE Editor",
          "Knowledgebase": "Knowledgebase",
          "SupportTicket": "SupportTicket",
          "Authentication": "Authentication",
          "Coming Soon": "Coming Soon",
          "Pinned": "Pinned",
          // Dashboard Custom
          "Bienvenido": "Welcome",
          "Hola": "Hello",
          "Usuario": "User",
          "Email": "Email",
          "Rol": "Role",
          "Teléfono": "Phone",
          "País": "Country",
          "Idioma": "Language",
          "Agregar Usuario": "Add User",
          "Nuevo Usuario": "New User",
          "Editar Usuario": "Edit User",
          "Actualizar": "Refresh",
          "Nombre": "Name",
          "Contraseña": "Password",
          "Nueva Contraseña": "New Password",
          "Código País Teléfono": "Country Phone Code",
          "Seleccionar país": "Select country",
          "Seleccionar rol": "Select role",
          "Crear": "Create",
          "Usuario actualizado exitosamente": "User updated successfully",
          "Usuario creado exitosamente": "User created successfully",
          "La contraseña es requerida": "Password is required",
          "Error al guardar usuario": "Error saving user",
          "Error al cargar datos": "Error loading data",
          "Dejar vacío para no cambiar": "Leave empty to not change",
          "Editar": "Edit",
          "Eliminar": "Delete",
          "Activo": "Active",
          "Inactivo": "Inactive",
          "No se encontraron usuarios": "No users found",
          "No disponible": "Not available",
          "No especificado": "Not specified",
          "Información del perfil": "Profile Information",
          "Super Administrador": "Super Administrator",
          "Tipos de casos": "Case Types",
          "Miembro desde": "Member since",
          "Idioma preferido": "Preferred Language",
          "Editar perfil": "Edit profile",
          "Miembro desde hace tiempo": "Member for a while",
          "Miembro desde hace": "Member for",
          "día": "day",
          "días": "days",
          "mes": "month",
          "meses": "months",
          "año": "year",
          "años": "years",
          "No hay información adicional disponible.": "No additional information available.",
          "Caso": "Case",
          "Petición familiar": "Family Petition",
          "Procesos consulares": "Consular Processes",
          "Ajuste de estatus": "Status Adjustment",
          "Perdones": "Pardons",
          "Permiso de trabajo": "Work Permit",
          "Corte": "Court",
          "Visa": "Visa",
          "Inmigración general": "General Immigration",
          "Consulta": "Consultation",
          "Consultas Totales": "Total Consultations",
          "Consultas Pendientes": "Pending Consultations",
          "Consultas Realizadas": "Completed Consultations",
          "Pagos Pendientes": "Pending Payments",
          "Accesos Rápidos": "Quick Access",
          "Gestión de Usuarios": "User Management",
          "Gestión de Países": "Countries Management",
          "Consultas Legales": "Legal Consultations",
          "Detalle de Consulta": "Consultation Detail",
          "Nueva Consulta Legal": "New Legal Consultation",
          "Pagos": "Payments",
          "Notificaciones": "Notifications",
          "Consultas Recientes": "Recent Consultations",
          "Nueva Consulta": "New Consultation",
          "Ver todas": "View All",
          "ID": "ID",
          "Fecha": "Date",
          "Hora": "Time",
          "Estado": "Status",
          "Pago": "Payment",
          "Cliente": "Client",
          "Buscar notificaciones...": "Search notifications...",
          "No se encontraron notificaciones": "No notifications found",
          "Notificación marcada como leída": "Notification marked as read",
          "Error al marcar notificación": "Error marking notification",
          "Notificación eliminada exitosamente": "Notification deleted successfully",
          "Error al eliminar notificación": "Error deleting notification",
          "Normal": "Normal",
          "Consulta Legal": "Legal Consultation",
          "Leídas": "Read",
          "No Leídas": "Unread",
          "Todas": "All",
          "Marcar como leída": "Mark as read",
          "Abogado": "Lawyer",
          "Acciones": "Actions",
          "Sin asignar": "Unassigned",
          "Notificaciones Recientes": "Recent Notifications",
          "sin leer": "unread",
          "Sin título": "No Title",
          "Pendiente": "Pending",
          "Cancelada": "Cancelled",
          "Reagendada": "Rescheduled",
          "Realizada": "Completed",
          "Realizado": "Completed",
          "Todos los estados": "All Statuses",
          "Todos los pagos": "All Payments",
          "Buscar por descripción...": "Search by description...",
          "Reagendar": "Reschedule",
          "Cancelar": "Cancel",
          "Aceptar": "Accept",
          "Cerrar": "Close",
          "Continuar": "Continue",
          "Cancelando...": "Canceling...",
          "Asignando...": "Assigning...",
          "Creando...": "Creating...",
          "Error de validación": "Validation Error",
          "Asignar Abogado": "Assign Lawyer",
          "Documentos": "Documents",
          "Sin estado": "No Status",
          "Fallido": "Failed",
          // Business Sidebar Menu
          "Principal": "Main",
          "Dashboard": "Dashboard",
          "Módulos": "Modules",
          "Lista de Consultas": "Consultations List",
          "Gestionar": "Manage",
          "Seguimiento de Casos": "Case Tracking",
          "Mis Casos": "My Cases",
          "Casos USCIS": "USCIS Cases",
          "Casos EOIR/NVC": "EOIR/NVC Cases",
          "Biblioteca de Recursos": "Resource Library",
          "Artículos": "Articles",
          "Guías": "Guides",
          "Preguntas Frecuentes": "Frequently Asked Questions",
          "Gestión de Recursos": "Resource Management",
          "Preparación de Documentos": "Document Preparation",
          "Formularios": "Forms",
          "Documentos Enviados": "Submitted Documents",
          "Revisión de Documentos": "Document Review",
          "Herramientas & Servicios": "Tools & Services",
          "Foro Comunitario": "Community Forum",
          "Foro": "Forum",
          "Moderación": "Moderation",
          "Noticias & Información": "News & Information",
          "Search": "Search",
          "Podcasts": "Podcasts",
          "Administración": "Administration",
          "Mi Perfil": "My Profile",
          "Editar Perfil": "Edit Profile",
          "¿Desea cerrar sesión?": "Do you want to log out?",
          "Esta acción cerrará tu sesión actual y deberás iniciar sesión nuevamente para acceder al sistema.": "This action will close your current session and you will need to log in again to access the system.",
          "Confirmar": "Confirm",
          "Nueva Password": "New Password",
          "Confirmar Nueva Password": "Confirm New Password",
          "Cambiar imagen": "Change image",
          "Ingresa tu nueva contraseña": "Enter your new password",
          "Confirma tu nueva contraseña": "Confirm your new password",
          "Cambiando...": "Changing...",
          "Cambiar Contraseña": "Change Password",
          "Actualizar Perfil": "Update Profile",
          "Guardando...": "Saving...",
          // Forgot Password
          "Ingresa tu email y te enviaremos un código de recuperación": "Enter your email and we'll send you a recovery code",
          "ejemplo@email.com": "example@email.com",
          "Enviando...": "Sending...",
          "Enviar Código": "Send Code",
          "¿Ya tienes una cuenta?": "Already have an account?",
          "Por favor ingresa tu email": "Please enter your email",
          "Código de recuperación enviado a tu email": "Recovery code sent to your email",
          "Error al solicitar recuperación de contraseña": "Error requesting password recovery",
          "Ingresa el código enviado a": "Enter the code sent to",
          "Código de Verificación": "Verification Code",
          "¿No recibiste el código?": "Didn't receive the code?",
          "Reenviando...": "Resending...",
          "Verificando...": "Verifying...",
          "Verificar Código": "Verify Code",
          "Sesión expirada. Por favor solicita un nuevo código": "Session expired. Please request a new code",
          "Por favor ingresa el código completo": "Please enter the complete code",
          "Error: ID de recuperación no encontrado": "Error: Recovery ID not found",
          "Código verificado correctamente": "Code verified successfully",
          "Código inválido o expirado": "Invalid or expired code",
          "Error al verificar el código": "Error verifying code",
          "Código reenviado a tu email": "Code resent to your email",
          "Error al reenviar el código": "Error resending code",
          "Mínimo 8 caracteres": "Minimum 8 characters",
          "Por favor ingresa una contraseña": "Please enter a password",
          "La contraseña debe tener al menos 8 caracteres": "Password must be at least 8 characters",
          "Las contraseñas no coinciden": "Passwords do not match",
          "Cambiando contraseña...": "Changing password...",
          "Contraseña cambiada exitosamente. Puedes iniciar sesión ahora.": "Password changed successfully. You can log in now.",
          "Error al cambiar la contraseña": "Error changing password",
          "ResetYourPassword": "Reset Your Password",
          "EnterOTP": "Enter OTP",
          "Resend": "Resend",
          "CreateYourPassword": "Create Your Password",
          "NewPassword": "New Password",
          "RetypePassword": "Retype Password",
          "SignIn": "Sign In",
          "Tarjetas de Usuario": "User Cards",
          "Roles y Permisos": "Roles and Permissions",
          "Gestión de Roles": "Role Management",
          "Gestión de Permisos": "Permission Management",
          "Nuevo Rol": "New Role",
          "Editar Rol": "Edit Role",
          "Rol eliminado exitosamente": "Role deleted successfully",
          "Estado del rol actualizado": "Role state updated",
          "Rol actualizado exitosamente": "Role updated successfully",
          "Rol creado exitosamente": "Role created successfully",
          "Error al guardar rol": "Error saving role",
          "Gestionar Permisos": "Manage Permissions",
          "Buscar permisos...": "Search permissions...",
          "Permiso eliminado del rol": "Permission removed from role",
          "Permiso agregado al rol": "Permission added to role",
          "Error al actualizar permisos": "Error updating permissions",
          "Quitar": "Remove",
          "Agregar": "Add",
          "permisos": "permissions",
          "Rol Público": "Public Role",
          "Nuevo Permiso": "New Permission",
          "Editar Permiso": "Edit Permission",
          "Estado del permiso actualizado": "Permission state updated",
          "Permiso actualizado exitosamente": "Permission updated successfully",
          "Error al guardar permiso": "Error saving permission",
          "La creación de permisos no está disponible desde la interfaz": "Permission creation is not available from the interface",
          "La creación de permisos debe hacerse desde el backend": "Permission creation must be done from the backend",
          "Confirmar Eliminación": "Confirm Deletion",
          "¿Estás seguro de que deseas eliminar este elemento?": "Are you sure you want to delete this item?",
          "Esta acción no se puede deshacer.": "This action cannot be undone.",
          "Código": "Code",
          "Países": "Countries",
          "Mis Pagos": "My Payments",
          "Historial de Pagos": "Payment History",
          "Gestión de Pagos": "Payment Management",
          "Mis Notificaciones": "My Notifications",
          "Enviar Notificación": "Send Notification",
          "Reportes": "Reports",
          "Reporte de Consultas": "Consultations Report",
          "Reporte de Documentos": "Documents Report",
          "Reporte de Casos": "Cases Report",
          "Analítica General": "General Analytics",
          "Configuración": "Settings",
          "Cerrar Sesión": "Log Out",
          "Configuración General": "General Settings",
          "Políticas y Privacidad": "Policies and Privacy",
          "Actualizaciones de App": "App Updates",
          "Historial de Acceso": "Access History",
          "Versiones APK": "APK Versions",
          "Gestión de Versiones APK": "APK Versions Management",
          "Crear Nueva Versión": "Create New Version",
          "Editar Versión": "Edit Version",
          "Versión": "Version",
          "URL": "URL",
          "Descripción": "Description",
          "Fecha de Creación": "Creation Date",
          "Buscar por versión...": "Search by version...",
          "No se encontraron versiones": "No versions found",
          "Error al cargar versiones": "Error loading versions",
          "Versión eliminada exitosamente": "Version deleted successfully",
          "Error al eliminar versión": "Error deleting version",
          "Estado de la versión actualizado": "Version state updated",
          "Error al cambiar estado": "Error changing state",
          "La versión es requerida": "Version is required",
          "La URL es requerida": "URL is required",
          "La URL no tiene un formato válido": "URL does not have a valid format",
          "Versión actualizada exitosamente": "Version updated successfully",
          "Versión creada exitosamente": "Version created successfully",
          "Error al guardar versión": "Error saving version",
          "Ejemplo: 1.0.0": "Example: 1.0.0",
          "Formato recomendado: número.número.número (ej: 1.0.0)": "Recommended format: number.number.number (e.g: 1.0.0)",
          "URL completa donde se encuentra el archivo APK": "Complete URL where the APK file is located",
          "Descripción de los cambios en esta versión...": "Description of changes in this version...",
          "Opcional: Descripción de los cambios o mejoras en esta versión": "Optional: Description of changes or improvements in this version",
          "¿Estás seguro de que deseas eliminar la versión": "Are you sure you want to delete version",
          // Access History
          "Buscar por usuario...": "Search by user...",
          "No se encontraron registros de acceso": "No access records found",
          "Fecha de Acceso": "Access Date",
          "Exitoso": "Successful",
          "IP": "IP",
          "Página": "Page",
          "de": "of",
          "Anterior": "Previous",
          "Siguiente": "Next",
          "Error al cargar historial de acceso": "Error loading access history",
          // Case Follow-Up
          "Casos Activos": "Active Cases",
          "Todos los Casos": "All Cases",
          "Casos con Relaciones": "Cases with Relations",
          "Casos de Abogados": "Lawyer Cases",
          "Casos de Clientes": "Client Cases",
          "Crear Alias": "Create Alias",
          "Consultar USCIS": "Query USCIS",
          "Agregar Nota": "Add Note",
          "Número de Caso USCIS": "USCIS Case Number",
          "Tipo de Caso": "Case Type",
          "USCIS": "USCIS",
          "EOIR": "EOIR",
          "CEAC": "CEAC",
          "Alias/Nombre": "Alias/Name",
          "Estado Actual": "Current Status",
          "Última Actualización": "Last Update",
          "Historial de Casos": "Case History",
          "Comentario": "Comment",
          "Respuesta USCIS": "USCIS Response",
          "Ver Detalle": "View Detail",
          "No se encontraron casos": "No cases found",
          "Error al cargar casos": "Error loading cases",
          "Alias creado exitosamente": "Alias created successfully",
          "Error al crear alias": "Error creating alias",
          "Caso consultado exitosamente": "Case queried successfully",
          "Error al consultar caso": "Error querying case",
          "Nota agregada exitosamente": "Note added successfully",
          "Error al agregar nota": "Error adding note",
          "El nombre es requerido": "Name is required",
          "El número de caso USCIS es requerido": "USCIS case number is required",
          "El tipo de caso es requerido": "Case type is required",
          "El comentario es requerido": "Comment is required",
          "Sugerencias": "Suggestions",
          "Seleccionar historial": "Select history",
          "Información del Caso": "Case Information",
          "Relaciones": "Relations",
          "Sin historial disponible": "No history available",
          "Consultando...": "Querying...",
          "Agregando...": "Adding...",
          "resultados": "results",
          "Todos los tipos": "All types",
          "Ingrese un nombre o alias para el caso": "Enter a name or alias for the case",
          "Resultado de la Consulta": "Query Result",
          "Guardar Resultado": "Save Result",
          "Consultar": "Query",
          "Seleccione un historial de caso": "Select a case history",
          "El comentario debe tener al menos 10 caracteres": "Comment must be at least 10 characters",
          "No hay historiales de caso disponibles para agregar notas": "No case histories available to add notes",
          "Ingrese un comentario sobre el caso...": "Enter a comment about the case...",
          "Mínimo 10 caracteres": "Minimum 10 characters",
          "Caso no encontrado": "Case not found",
          "Volver a la lista": "Back to list",
          "Volver": "Back",
          "Alien Number EOIR": "Alien Number EOIR",
          "Información de relaciones disponible en la vista completa": "Relationship information available in full view",
          "Todos": "All",
          "Por Abogado": "By Lawyer",
          "Por Cliente": "By Client",
        },
      },
      cn: {
        translations: {
          "General": "通用",
          "Dashboards": "仪表板",
          "Default": "默认",
          "Project": "项目",
          "Ecommerce": "电子商务",
          "Online Course":"「網上課程」",
          "Education": "教育",
          "Widgets": "小部件",
          "Chart": "图表",
          "Applications": "应用程序",
          "Project List": "项目列表",
          "Create New": "创建新",
          "File Manager": "文件管理器",
          "Add Product": "添加产品",
          "Product": "产品",
          "Product Page": "产品页面",
          "Product List": "产品列表",
          "Payment Details": "付款详情",
          "Order History": "订单历史",
          "Invoice": "发票",
          "Invoice-1": "发票-1",
          "Invoice-2": "发票-2",
          "Invoice-3": "发票-3",
          "Invoice-4": "发票-4",
          "Invoice-5": "发票-5",
          "Invoice-6": "发票-6",
          "Cart": "购物车",
          "Wishlist": "愿望清单",
          "Checkout": "结账",
          "Pricing": "定价",
          "Chat": "聊天",
          "Users": "用户",
          "Letter Box": "邮箱",
          "Private Chat": "私聊",
          "Group Chat": "群聊",
          "User Profile": "用户资料",
          "User Edit": "编辑用户",
          "User Cards": "用户卡片",
          "Bookmarks": "书签",
          "Contacts": "联系人",
          "Task": "任务",
          "Calendar": "日历",
          "Social App": "社交应用",
          "Todo": "待办事项",
          "Search Result": "搜索结果",
          "Form Validation": "表单验证",
          "Base Inputs": "基本输入",
          "Checkbox & Radio": "复选框和单选按钮",
          "Input Groups": "输入组",
          "Input Mask": "输入掩码",
          "Mega Option": "超级选项",
          "Datepicker": "日期选择器",
          "Touchspin": "Touchspin",
          "Switch": "开关",
          "Forms": "表单",
          "Form Controls": "表单控件",
          "Forms & Table": "表单和表格",
          "Typeahead": "类型提示",
          "Clipboard": "剪贴板",
          "Form Widget": "表单小部件",
          "Form Wizard 1": "表单向导1",
          "Form Wizard 2": "表单向导2",
          "Two Factor": "双因素认证",
          "Form Layout": "表单布局",
          "Table": "表格",
          "Reactstrap Tables": "Reactstrap表格",
          "Basic Tables": "基本表格",
          "Table Components": "表格组件",
          "Data Tables": "数据表",
          "Basic Init": "基本初始化",
          "Advance Init": "高级初始化",
          "API": "API",
          "Data Source": "数据源",
          "Components": "组件",
          "Typography": "排版",
          "Avatars": "头像",
          "Helper Classes": "辅助类",
          "Grid": "网格",
          "Tag & Pills": "标签和药丸",
          "Progress": "进度",
          "Modal": "模态框",
          "Alert": "警告",
          "Popover": "弹出框",
          "Tooltip": "工具提示",
          "Dropdown": "下拉菜单",
          "Accordion": "手风琴",
          "Tabs": "选项卡",
          "Lists": "列表",
          "Bonus-Ui": "附加界面",
          "Scrollable": "可滚动",
          "Tree View": "树视图",
          "Toasts": "消息提醒",
          "Rating": "评分",
          "Dropzone": "文件上传",
          "Tour": "新手导览",
          "SweetAlert2": "SweetAlert2",
          "Carousel": "走马灯",
          "Ribbons": "带子",
          "Pagination": "分页",
          "Breadcrumb": "面包屑",
          "Range Slider": "范围滑块",
          "Image Cropper": "图片裁剪",
          "Basic Card": "基本卡片",
          "Creative Card": "创意卡片",
          "Timeline": "时间线",
          "Icons": "图标",
          "Flag Icon": "国旗图标",
          "Fontawesome Icon": "Font Awesome 图标",
          "Ico Icon": "Ico 图标",
          "Themify Icon": "Themify 图标",
          "Feather Icon": "Feather 图标",
          "Weather Icon": "天气图标",
          "Buttons": "按钮",
          "Default Style": "默认样式",
          "Flat Style": "扁平样式",
          "Edge Style": "边框样式",
          "Raised Style": "浮凸样式",
          "Button Group": "按钮组",
          "Charts": "图表",
          "Apex Chart": "Apex 图表",
          "Google Chart": "谷歌图表",
          "Chart JS Chart": "Chart JS 图表",
          "Pages": "页面",
          "Sample Page": "示例页面",
          "Others": "其他",
          "Error Pages": "错误页面",
          "Error 400": "错误 400",
          "Error 401": "错误 401",
          "Error 403": "错误 403",
          "Error 404": "错误 404",
          "Error 500": "错误 500",
          "Error 503": "错误 503",
          "Login Simple": "简单登录",
          "Login with Bg Image": "带背景图片的登录",
          "Login With Image Two": "带两张图片的登录",
          "Login With Validation": "带验证的登录",
          "Login With Tooltip": "带提示的登录",
          "Login With Sweetalert": "带 SweetAlert 的登录",
          "Register Simple": "简单注册",
          "Register With Bg Image": "带背景图片的注册",
          "Register With Bg Two": "带背景图片的注册",
          "Register Wizard": "注册向导",
          "Unlock User": "解锁用户",
          "Forget Password": "忘记密码",
          "Reset Password": "重设密码",
          "Maintenance": "维护",
          "Coming Simple": "即将上线",
          "Coming With Bg Video": "带背景视频的即将上线",
          "Coming With Bg Image": "带背景图片的即将上线",
          "Miscellaneous": "其他",
          "Gallery": "图库",
          "Gallery Grids": "图库网格",
          "Gallery Grid Desc": "图库网格描述",
          "Masonry Gallery": "砖瓦图库",
          "Masonry With Desc": "砖瓦图库描述",
          "Hover Effect": "悬停效果",
          "Blog": "博客",
          "Blog Details": "博客详情",
          "Blog Single": "单篇博客",
          "Add Post": "添加文章",
          "FAQ": "常见问题",
          "Job Search": "职位搜索",
          "Cards View": "卡片视图",
          "List View": "列表视图",
          "Job Detail": "职位详情",
          "Apply": "申请",
          "Learning": "学习",
          "Learning List": "学习列表",
          "Detailed Course": "详细课程",
          "Map": "地图",
          "Google Map": "谷歌地图",
          "Leaflet Map": "Leaflet 地图",
          "Editor": "编辑器",
          "CK Editor": "CK 编辑器",
          "MDE Editor": "MDE 编辑器",
          "ACE Editor": "ACE 编辑器",
          "Knowledgebase": "知识库",
          "Ui-Kits": "界面套件",
          "SupportTicket": "支持工单",
          "Authentication": "身份验证",
          "Login With Bg Image": "带背景图像的登录",
          "Pinned": "已固定",
          "Coming Soon": "即将上线",
        },
      },
      ae: {
        translations: {
          "General": "عامة",
          "Dashboards": "لوحات القيادة",
          "Default": "افتراضي",
          "Project": "مشروع",
          "Online Course":"دورة على شبكة الإنترنت",
          "Ecommerce": "التجارة الإلكترونية",
          "Education": "التعليم",
          "Widgets": "حاجيات",
          "Chart": "رسم بياني",
          "Applications": "تطبيقات",
          "Project List": "قائمة المشروع",
          "Create New": "إنشاء جديد",
          "File Manager": "مدير الملفات",
          "Add Product": "إضافة منتج",
          "Product": "منتج",
          "Product Page": "صفحة المنتج",
          "Product List": "قائمة المنتج",
          "Payment Details": "تفاصيل الدفع",
          "Order History": "تاريخ الطلب",
          "Invoice": "فاتورة",
          "Invoice-1": "فاتورة-1",
          "Invoice-2": "فاتورة-2",
          "Invoice-3": "فاتورة-3",
          "Invoice-4": "فاتورة-4",
          "Invoice-5": "فاتورة-5",
          "Invoice-6": "فاتورة-6",
          "Cart": "عربة التسوق",
          "Wishlist": "قائمة الرغبات",
          "Checkout": "السداد",
          "Pricing": "التسعير",
          "Chat": "دردشة",
          "Users": "المستخدمين",
          "Letter Box": "صندوق البريد",
          "Private Chat": "الدردشة الخاصة",
          "Group Chat": "الدردشة الجماعية",
          "User Profile": "ملف المستخدم",
          "User Edit": "تحرير المستخدم",
          "User Cards": "بطاقات المستخدم",
          "Bookmarks": "الإشارات المرجعية",
          "Contacts": "جهات الاتصال",
          "Task": "المهمة",
          "Calendar": "التقويم",
          "Social App": "تطبيق اجتماعي",
          "Todo": "قائمة المهام",
          "Search Result": "نتائج البحث",
          "Form Validation": "التحقق من النموذج",
          "Base Inputs": "المدخلات الأساسية",
          "Checkbox & Radio": "خانات الاختيار والراديو",
          "Input Groups": "مجموعات المدخلات",
          "Input Mask": "قناع المدخلات",
          "Mega Option": "خيار ميجا",
          "Datepicker": "منتقي التاريخ",
          "Touchspin": "اللمس الدوار",
          "Switch": "التبديل",
          "Forms": "النماذج",
          "Form Controls": "عناصر التحكم في النموذج",
          "Forms & Table": "النماذج والجداول",
          "Typeahead": "التنبؤ التلقائي",
          "Clipboard": "الحافظة",
          "Form Widget": "عنصر واجهة النموذج",
          "Form Wizard 1": "معالج النموذج 1",
          "Form Wizard 2": "معالج النموذج 2",
          "Two Factor": "العاملين بعاملين",
          "Form Layout": "تخطيط النموذج",
          "Table": "الجدول",
          "Reactstrap Tables": "جداول Reactstrap",
          "Basic Tables": "الجداول الأساسية",
          "Table Components": "مكونات الجدول",
          "Data Tables": "جداول البيانات",
          "Basic Init": "البدء الأساسي",
          "Advance Init": "البدء المتقدم",
          "API": "واجهة برمجة التطبيقات",
          "Data Source": "مصدر البيانات",
          "Components": "المكونات",
          "Typography": "الأسلوب الطباعي",
          "Avatars": "الصور الرمزية",
          "Helper Classes": "فصول المساعدة",
          "Grid": "الشبكة",
          "Tag & Pills": "العلامة والأقراص",
          "Progress": "التقدم",
          "Modal": "نافذة منبثقة",
          "Alert": "تنبيه",
          "Popover": "البوب أوفر",
          "Tooltip": "تلميح",
          "Ui-Kits": "مجموعات واجهة المستخدم",
          "Dropdown": "القائمة المنسدلة",
          "Accordion": "الأكورديون",
          "Tabs": "علامات التبويب",
          "Lists": "القوائم",
          "Bonus-Ui": "واجهة المكافآت",
          "Scrollable": "قابل للتمرير",
          "Tree View": "عرض الشجرة",
          "Toasts": "التنبيهات",
          "Rating": "التقييم",
          "Dropzone": "منطقة الإفلات",
          "Tour": "جولة",
          "SweetAlert2": "التنبيه الحلو 2",
          "Carousel": "ساحة البوم البوم البوم",
          "Ribbons": "الشرائط",
          "Pagination": "ترقيم الصفحات",
          "Breadcrumb": "فتات الخبز",
          "Range Slider": "شريط النطاق",
          "Image Cropper": "أداة القص للصور",
          "Basic Card": "بطاقة أساسية",
          "Creative Card": "بطاقة إبداعية",
          "Timeline": "الجدول الزمني",
          "Icons": "الأيقونات",
          "Flag Icon": "أيقونة العلم",
          "Fontawesome Icon": "أيقونة Fontawesome",
          "Ico Icon": "أيقونة Ico",
          "Themify Icon": "أيقونة Themify",
          "Feather Icon": "أيقونة Feather",
          "Weather Icon": "أيقونة الطقس",
          "Buttons": "أزرار",
          "Default Style": "الأسلوب الافتراضي",
          "Flat Style": "الأسلوب المسطح",
          "Edge Style": "الأسلوب الحاد",
          "Raised Style": "الأسلوب المرتفع",
          "Button Group": "مجموعة الأزرار",
          "Charts": "الرسوم البيانية",
          "Apex Chart": "رسم بياني Apex",
          "Google Chart": "رسم بياني Google",
          "Chart JS Chart": "رسم بياني Chart JS",
          "Pages": "الصفحات",
          "Sample Page": "صفحة عينة",
          "Others": "أخرى",
          "Error Pages": "صفحات الخطأ",
          "Error 400": "خطأ 400",
          "Error 401": "خطأ 401",
          "Error 403": "خطأ 403",
          "Error 404": "خطأ 404",
          "Error 500": "خطأ 500",
          "Error 503": "خطأ 503",
          "Login Simple": "تسجيل الدخول البسيط",
          "Login with Bg Image": "تسجيل الدخول مع صورة الخلفية",
          "Login With Image Two": "تسجيل الدخول مع صورتين",
          "Login With Validation": "تسجيل الدخول مع التحقق",
          "Login With Tooltip": "تسجيل الدخول مع تلميح",
          "Login With Sweetalert": "تسجيل الدخول مع تنبيه Sweetalert",
          "Register Simple": "التسجيل البسيط",
          "Register With Bg Image": "التسجيل مع صورة الخلفية",
          "Register With Bg Two": "التسجيل مع صورتين",
          "Register Wizard": "معالج التسجيل",
          "Unlock User": "فتح المستخدم",
          "Forget Password": "نسيت كلمة المرور",
          "Reset Password": "إعادة تعيين كلمة المرور",
          "Maintenance": "الصيانة",
          "Coming Simple": "قريبًا بسيط",
          "Coming With Bg Video": "قريبًا مع فيديو الخلفية",
          "Coming With Bg Image": "قريبًا مع صورة الخلفية",
          "Miscellaneous": "متنوع",
          "Gallery": "المعرض",
          "Gallery Grids": "شبكات المعرض",
          "Gallery Grid Desc": "وصف الشبكة في المعرض",
          "Masonry Gallery": "معرض الطوب",
          "Masonry With Desc": "مع الوصف",
          "Hover Effect": "تأثير التحويم",
          "Blog": "المدونة",
          "Blog Details": "تفاصيل المدونة",
          "Blog Single": "مدونة فردية",
          "Add Post": "إضافة منشور",
          "FAQ": "الأسئلة الشائعة",
          "Job Search": "بحث عن وظيفة",
          "Cards View": "عرض البطاقات",
          "List View": "عرض القائمة",
          "Job Detail": "تفاصيل الوظيفة",
          "Apply": "تقديم الطلب",
          "Learning": "التعلم",
          "Learning List": "قائمة التعلم",
          "Detailed Course": "دورة مفصلة",
          "Map": "الخريطة",
          "Google Map": "الخريطة من Google",
          "Leaflet Map": "الخريطة من Leaflet",
          "Editor": "المحرر",
          "CK Editor": "محرر CK",
          "MDE Editor": "محرر MDE",
          "ACE Editor": "محرر ACE",
          "Knowledgebase": "قاعدة المعرفة",
          "SupportTicket": "تذكرة الدعم",
          "Authentication": "المصادقة",
          "Login With Bg Image": "تسجيل الدخول مع صورة خلفية",
          "Pinned": "مثبت",
          "Coming Soon": "قريبًا",
        },
      },
      du: {
        translations: {
          "General": "Allgemein",
          "Dashboards": "Dashboards",
          "Default": "Standard",
          "Project": "Projekt",
          "Online Course":"Online cursus",
          "Ecommerce": "E-Commerce",
          "Education": "Bildung",
          "Widgets": "Widgets",
          "Chart": "Diagramm",
          "Applications": "Anwendungen",
          "Project List": "Projektliste",
          "Create New": "Neu erstellen",
          "File Manager": "Dateimanager",
          "Add Product": "Produkt hinzufügen",
          "Product": "Produkt",
          "Product Page": "Produktseite",
          "Product List": "Produktliste",
          "Payment Details": "Zahlungsdetails",
          "Order History": "Bestellverlauf",
          "Invoice": "Rechnung",
          "Invoice-1": "Rechnung-1",
          "Invoice-2": "Rechnung-2",
          "Invoice-3": "Rechnung-3",
          "Invoice-4": "Rechnung-4",
          "Invoice-5": "Rechnung-5",
          "Invoice-6": "Rechnung-6",
          "Cart": "Warenkorb",
          "Wishlist": "Wunschliste",
          "Checkout": "Kasse",
          "Pricing": "Preisgestaltung",
          "Chat": "Chat",
          "Users": "Benutzer",
          "Letter Box": "Briefkasten",
          "Private Chat": "Privater Chat",
          "Group Chat": "Gruppenchat",
          "User Profile": "Benutzerprofil",
          "User Edit": "Benutzer bearbeiten",
          "User Cards": "Benutzerkarten",
          "Bookmarks": "Lesezeichen",
          "Contacts": "Kontakte",
          "Task": "Aufgabe",
          "Calendar": "Kalender",
          "Social App": "Soziale App",
          "Todo": "To-Do",
          "Search Result": "Suchergebnis",
          "Form Validation": "Formularvalidierung",
          "Base Inputs": "Grundlegende Eingaben",
          "Checkbox & Radio": "Checkbox & Radio",
          "Input Groups": "Eingabegruppen",
          "Input Mask": "Eingabemaske",
          "Mega Option": "Mega-Option",
          "Datepicker": "Datumsauswahl",
          "Touchspin": "Touchspin",
          "Switch": "Schalter",
          "Forms": "Formulare",
          "Form Controls": "Formularelemente",
          "Forms & Table": "Formulare & Tabelle",
          "Typeahead": "Typsuche",
          "Clipboard": "Zwischenablage",
          "Form Widget": "Formularelement",
          "Form Wizard 1": "Formular-Assistent 1",
          "Form Wizard 2": "Formular-Assistent 2",
          "Two Factor": "Zwei-Faktor",
          "Form Layout": "Formularlayout",
          "Table": "Tabelle",
          "Reactstrap Tables": "Reactstrap-Tabellen",
          "Basic Tables": "Grundlegende Tabellen",
          "Table Components": "Tabellenkomponenten",
          "Data Tables": "Daten-Tabellen",
          "Basic Init": "Grundlegende Initialisierung",
          "Advance Init": "Erweiterte Initialisierung",
          "API": "API",
          "Data Source": "Datenquelle",
          "Components": "Komponenten",
          "Typography": "Typografie",
          "Avatars": "Avatare",
          "Helper Classes": "Hilfsklassen",
          "Grid": "Raster",
          "Tag & Pills": "Schlagwörter & Pillen",
          "Progress": "Fortschritt",
          "Modal": "Modales Fenster",
          "Alert": "Benachrichtigung",
          "Popover": "Popover",
          "Tooltip": "Tooltip",
          "Dropdown": "Dropdown",
          "Accordion": "Akkordeon",
          "Tabs": "Tabs",
          "Lists": "Listen",
          "Bonus-Ui": "Zusatz-UI",
          "Scrollable": "Scrollbar",
          "Tree View": "Baumansicht",
          "Toasts": "Benachrichtigungen",
          "Rating": "Bewertung",
          "Dropzone": "Dateiablage",
          "Tour": "Tour",
          "SweetAlert2": "SweetAlert2",
          "Carousel": "Eulenkarussell",
          "Ribbons": "Bänder",
          "Pagination": "Seitennummerierung",
          "Breadcrumb": "Brotkrumen",
          "Range Slider": "Bereichsschieberegler",
          "Image Cropper": "Bildzuschnitt",
          "Basic Card": "Grundlegende Karte",
          "Creative Card": "Kreative Karte",
          "Timeline": "Zeitachse",
          "Icons": "Symbole",
          "Flag Icon": "Flaggensymbol",
          "Fontawesome Icon": "Font Awesome Symbol",
          "Ico Icon": "Ico Symbol",
          "Themify Icon": "Themify Symbol",
          "Feather Icon": "Feather Symbol",
          "Weather Icon": "Wettersymbol",
          "Buttons": "Schaltflächen",
          "Default Style": "Standardstil",
          "Flat Style": "Flacher Stil",
          "Edge Style": "Edge-Stil",
          "Raised Style": "Erhöhter Stil",
          "Button Group": "Schaltflächengruppe",
          "Charts": "Diagramme",
          "Apex Chart": "Apex Diagramm",
          "Ui-Kits": "Benutzeroberflächen-Kits",
          "Google Chart": "Google Diagramm",
          "Chart JS Chart": "Chart JS Diagramm",
          "Pages": "Seiten",
          "Sample Page": "Beispielseite",
          "Others": "Andere",
          "Error Pages": "Fehlerseiten",
          "Error 400": "Fehler 400",
          "Error 401": "Fehler 401",
          "Error 403": "Fehler 403",
          "Error 404": "Fehler 404",
          "Error 500": "Fehler 500",
          "Error 503": "Fehler 503",
          "Login Simple": "Einfaches Anmelden",
          "Login with Bg Image": "Anmelden mit Hintergrundbild",
          "Login With Image Two": "Anmelden mit zwei Bildern",
          "Login With Validation": "Anmelden mit Validierung",
          "Login With Tooltip": "Anmelden mit Tooltip",
          "Login With Sweetalert": "Anmelden mit SweetAlert",
          "Register Simple": "Einfache Registrierung",
          "Register With Bg Image": "Registrieren mit Hintergrundbild",
          "Register With Bg Two": "Registrieren mit zwei Bildern",
          "Register Wizard": "Registrierungsassistent",
          "Unlock User": "Benutzer entsperren",
          "Forget Password": "Passwort vergessen",
          "Reset Password": "Passwort zurücksetzen",
          "Maintenance": "Wartung",
          "Coming Simple": "Einfache Ankündigung",
          "Coming With Bg Video": "Ankündigung mit Hintergrundvideo",
          "Coming With Bg Image": "Ankündigung mit Hintergrundbild",
          "Miscellaneous": "Sonstiges",
          "Gallery": "Galerie",
          "Gallery Grids": "Galerie Raster",
          "Gallery Grid Desc": "Galerie Raster Beschreibung",
          "Masonry Gallery": "Mauerwerk-Galerie",
          "Masonry With Desc": "Mauerwerk mit Beschreibung",
          "Hover Effect": "Hover-Effekt",
          "Blog": "Blog",
          "Blog Details": "Blogdetails",
          "Blog Single": "Einzelner Blog",
          "Add Post": "Beitrag hinzufügen",
          "FAQ": "FAQ",
          "Job Search": "Job-Suche",
          "Cards View": "Kartenansicht",
          "List View": "Listenansicht",
          "Job Detail": "Jobdetails",
          "Apply": "Bewerben",
          "Learning": "Lernen",
          "Learning List": "Lernliste",
          "Detailed Course": "Detaillierter Kurs",
          "Map": "Karte",
          "Google Map": "Google Karte",
          "Leaflet Map": "Leaflet Karte",
          "Editor": "Editor",
          "CK Editor": "CK Editor",
          "MDE Editor": "MDE Editor",
          "ACE Editor": "ACE Editor",
          "Knowledgebase": "Wissensdatenbank",
          "SupportTicket": "Support-Ticket",
          "Authentication": "Authentifizierung",
          "Login With Bg Image": "Anmeldung mit Hintergrundbild",
          "Pinned": "Gepinnt",
          "Coming Soon": "Demnächst",
        },
      },
      es: {
        translations: {
          "General": "General",
          "Dashboards": "Paneles",
          "Default": "Inicio",
          "Project": "Proyecto",
          "Online Course":"Curso por Internet",
          "Ecommerce": "Comercio Electrónico",
          "Education": "Educación",
          "Widgets": "Widgets",
          "Chart": "Gráfico",
          "Applications": "Aplicaciones",
          "Project List": "Lista de Proyectos",
          "Create New": "Crear Nuevo",
          "File Manager": "Gestor de Archivos",
          "Add Product": "Agregar Producto",
          "Product": "Producto",
          "Product Page": "Página de Producto",
          "Product List": "Lista de Productos",
          "Payment Details": "Detalles de Pago",
          "Order History": "Historial de Pedidos",
          "Invoice": "Factura",
          "Invoice-1": "Factura-1",
          "Invoice-2": "Factura-2",
          "Invoice-3": "Factura-3",
          "Invoice-4": "Factura-4",
          "Invoice-5": "Factura-5",
          "Invoice-6": "Factura-6",
          "Cart": "Carrito",
          "Wishlist": "Lista de Deseos",
          "Checkout": "Pagar",
          "Pricing": "Precios",
          "Chat": "Chat",
          "Users": "Usuarios",
          "Letter Box": "Buzón de Correo",
          "Private Chat": "Chat Privado",
          "Group Chat": "Chat de Grupo",
          "User Profile": "Perfil de Usuario",
          "User Edit": "Editar Usuario",
          "User Cards": "Tarjetas de Usuario",
          "Bookmarks": "Marcadores",
          "Contacts": "Contactos",
          "Task": "Tarea",
          "Calendar": "Calendario",
          "Social App": "Aplicación Social",
          "Todo": "Tareas Pendientes",
          "Search Result": "Resultado de Búsqueda",
          "Consulta": "Consulta",
          "Form Validation": "Validación de Formulario",
          "Base Inputs": "Entradas Básicas",
          "Checkbox & Radio": "Casillas de Verificación y Radio",
          "Input Groups": "Grupos de Entrada",
          "Input Mask": "Máscara de Entrada",
          "Mega Option": "Opción Mega",
          "Datepicker": "Selector de Fecha",
          "Touchspin": "Selector Numérico",
          "Switch": "Interruptor",
          "Forms": "Formularios",
          "Form Controls": "Controles de Formulario",
          "Forms & Table": "Formularios y Tabla",
          "Typeahead": "Búsqueda Predictiva",
          "Clipboard": "Portapapeles",
          "Form Widget": "Widget de Formulario",
          "Form Wizard 1": "Asistente de Formulario 1",
          "Form Wizard 2": "Asistente de Formulario 2",
          "Two Factor": "Doble Factor",
          "Form Layout": "Diseño de Formulario",
          "Table": "Tabla",
          "Reactstrap Tables": "Tablas Reactstrap",
          "Basic Tables": "Tablas Básicas",
          "Table Components": "Componentes de Tabla",
          "Data Tables": "Tablas de Datos",
          "Basic Init": "Inicio Básico",
          "Advance Init": "Inicio Avanzado",
          "API": "API",
          "Data Source": "Fuente de Datos",
          "Components": "Componentes",
          "Typography": "Tipografía",
          "Avatars": "Avatares",
          "Helper Classes": "Clases de Ayuda",
          "Grid": "Cuadrícula",
          "Tag & Pills": "Etiquetas y Píldoras",
          "Progress": "Progreso",
          "Modal": "Modal",
          "Alert": "Alerta",
          "Popover": "Popover",
          "Tooltip": "Información sobre Herramientas",
          "Dropdown": "Menú Desplegable",
          "Accordion": "Acordeón",
          "Tabs": "Pestañas",
          "Lists": "Listas",
          "Bonus-Ui": "UI Adicional",
          "Scrollable": "Desplazable",
          "Tree View": "Vista de Árbol",
          "Toasts": "Notificaciones",
          "Rating": "Valoración",
          "Dropzone": "Zona de Descarga",
          "Tour": "Recorrido",
          "SweetAlert2": "SweetAlert2",
          "Carousel": "Carrusel",
          "Ribbons": "Cintas",
          "Pagination": "Paginación",
          "Breadcrumb": "Migas de Pan",
          "Range Slider": "Control Deslizante de Rango",
          "Image Cropper": "Recortador de Imagen",
          "Basic Card": "Tarjeta Básica",
          "Creative Card": "Tarjeta Creativa",
          "Timeline": "Línea de Tiempo",
          "Icons": "Iconos",
          "Flag Icon": "Icono de Bandera",
          "Fontawesome Icon": "Icono Font Awesome",
          "Ico Icon": "Icono Ico",
          "Themify Icon": "Icono Themify",
          "Feather Icon": "Icono Feather",
          "Weather Icon": "Icono del Tiempo",
          "Buttons": "Botones",
          "Default Style": "Estilo Predeterminado",
          "Flat Style": "Estilo Plano",
          "Edge Style": "Estilo Edge",
          "Raised Style": "Estilo Elevado",
          "Button Group": "Grupo de Botones",
          "Charts": "Gráficos",
          "Apex Chart": "Gráfico Apex",
          "Google Chart": "Gráfico de Google",
          "Chart JS Chart": "Gráfico de Chart JS",
          "Pages": "Páginas",
          "Sample Page": "Página de Ejemplo",
          "Others": "Otros",
          "Error Pages": "Páginas de Error",
          "Error 400": "Error 400",
          "Error 401": "Error 401",
          "Error 403": "Error 403",
          "Error 404": "Error 404",
          "Error 500": "Error 500",
          "Error 503": "Error 503",
          "Login Simple": "Inicio de Sesión Simple",
          "Login with Bg Image": "Inicio de Sesión con Imagen de Fondo",
          "Login With Image Two": "Inicio de Sesión con Dos Imágenes",
          "Login With Validation": "Inicio de Sesión con Validación",
          "Login With Tooltip": "Inicio de Sesión con Información Emergente",
          "Login With Sweetalert": "Inicio de Sesión con SweetAlert",
          "Register Simple": "Registro Simple",
          "Register With Bg Image": "Registro con Imagen de Fondo",
          "Register With Bg Two": "Registro con Dos Imágenes",
          "Register Wizard": "Asistente de Registro",
          "Unlock User": "Desbloquear Usuario",
          "Forget Password": "Olvidé mi Contraseña",
          "Reset Password": "Restablecer Contraseña",
          "Maintenance": "Mantenimiento",
          "Coming Simple": "Próximamente Simple",
          "Coming With Bg Video": "Próximamente con Video de Fondo",
          "Coming With Bg Image": "Próximamente con Imagen de Fondo",
          "Miscellaneous": "Misceláneo",
          "Gallery": "Galería",
          "Gallery Grids": "Galería en Cuadrícula",
          "Gallery Grid Desc": "Descripción de la Galería en Cuadrícula",
          "Masonry Gallery": "Galería de Albañilería",
          "Masonry With Desc": "Albañilería con Descripción",
          "Hover Effect": "Efecto de Desplazamiento",
          "Blog": "Blog",
          "Blog Details": "Detalles del Blog",
          "Blog Single": "Entrada de Blog Individual",
          "Add Post": "Agregar Entrada",
          "FAQ": "Preguntas Frecuentes",
          "Job Search": "Búsqueda de Trabajo",
          "Cards View": "Vista de Tarjetas",
          "List View": "Vista de Lista",
          "Job Detail": "Detalle del Trabajo",
          "Apply": "Solicitar",
          "Learning": "Aprendizaje",
          "Learning List": "Lista de Aprendizaje",
          "Detailed Course": "Curso Detallado",
          "Map": "Mapa",
          "Google Map": "Mapa de Google",
          "Leaflet Map": "Mapa de Leaflet",
          "Editor": "Editor",
          "CK Editor": "Editor CK",
          "MDE Editor": "Editor MDE",
          "ACE Editor": "Editor ACE",
          "Knowledgebase": "Base de Conocimientos",
          "Ui-Kits": "Kits de Interfaz de Usuario.",
          "SupportTicket": "Ticket de Soporte",
          "Authentication": "Autenticación",
          "Login With Bg Image": "Inicio de sesión con imagen de fondo",
          "Pinned": "Fijado",
          "Coming Soon": "Próximamente",
          // Dashboard Custom
          "Bienvenido": "Bienvenido",
          "Hola": "Hola",
          "Usuario": "Usuario",
          "Email": "Correo",
          "Rol": "Rol",
          "Teléfono": "Teléfono",
          "Nuevo Usuario": "Nuevo Usuario",
          "Editar Usuario": "Editar Usuario",
          "Actualizar": "Actualizar",
          "Nombre": "Nombre",
          "Contraseña": "Contraseña",
          "Nueva Contraseña": "Nueva Contraseña",
          "Código País Teléfono": "Código País Teléfono",
          "Seleccionar país": "Seleccionar país",
          "Seleccionar rol": "Seleccionar rol",
          "Crear": "Crear",
          "Usuario actualizado exitosamente": "Usuario actualizado exitosamente",
          "Usuario creado exitosamente": "Usuario creado exitosamente",
          "La contraseña es requerida": "La contraseña es requerida",
          "Error al guardar usuario": "Error al guardar usuario",
          "Error al cargar datos": "Error al cargar datos",
          "Dejar vacío para no cambiar": "Dejar vacío para no cambiar",
          "Editar": "Editar",
          "Eliminar": "Eliminar",
          "Activo": "Activo",
          "Inactivo": "Inactivo",
          "No se encontraron usuarios": "No se encontraron usuarios",
          "No disponible": "No disponible",
          "No especificado": "No especificado",
          "Información del perfil": "Información del perfil",
          "Super Administrador": "Super Administrador",
          "Tipos de casos": "Tipos de casos",
          "Miembro desde": "Miembro desde",
          "Idioma preferido": "Idioma preferido",
          "Editar perfil": "Editar perfil",
          "Miembro desde hace tiempo": "Miembro desde hace tiempo",
          "Miembro desde hace": "Miembro desde hace",
          "día": "día",
          "días": "días",
          "mes": "mes",
          "meses": "meses",
          "año": "año",
          "años": "años",
          "No hay información adicional disponible.": "No hay información adicional disponible.",
          "Caso": "Caso",
          "Petición familiar": "Petición familiar",
          "Procesos consulares": "Procesos consulares",
          "Ajuste de estatus": "Ajuste de estatus",
          "Perdones": "Perdones",
          "Permiso de trabajo": "Permiso de trabajo",
          "Corte": "Corte",
          "Visa": "Visa",
          "Inmigración general": "Inmigración general",
          "País": "País",
          "Idioma": "Idioma",
          "Agregar Usuario": "Agregar Usuario",
          "Consultas Totales": "Consultas Totales",
          "Consultas Pendientes": "Consultas Pendientes",
          "Consultas Realizadas": "Consultas Realizadas",
          "Pagos Pendientes": "Pagos Pendientes",
          "Accesos Rápidos": "Accesos Rápidos",
          "Gestión de Usuarios": "Gestión de Usuarios",
          "Gestión de Países": "Gestión de Países",
          "Nuevo País": "Nuevo País",
          "Editar País": "Editar País",
          "País eliminado exitosamente": "País eliminado exitosamente",
          "País actualizado exitosamente": "País actualizado exitosamente",
          "País creado exitosamente": "País creado exitosamente",
          "No se encontraron países": "No se encontraron países",
          "El código es requerido": "El código es requerido",
          "Código del país (ej: US, MX, ES)": "Código del país (ej: US, MX, ES)",
          "Consultas Legales": "Consultas Legales",
          "Detalle de Consulta": "Detalle de Consulta",
          "Nueva Consulta Legal": "Nueva Consulta Legal",
          "Pagos": "Pagos",
          "Notificaciones": "Notificaciones",
          "Consultas Recientes": "Consultas Recientes",
          "Nueva Consulta": "Nueva Consulta",
          "Ver todas": "Ver todas",
          "ID": "ID",
          "Fecha": "Fecha",
          "Hora": "Hora",
          "Estado": "Estado",
          "Pago": "Pago",
          "Cliente": "Cliente",
          "Buscar notificaciones...": "Buscar notificaciones...",
          "No se encontraron notificaciones": "No se encontraron notificaciones",
          "Notificación marcada como leída": "Notificación marcada como leída",
          "Error al marcar notificación": "Error al marcar notificación",
          "Notificación eliminada exitosamente": "Notificación eliminada exitosamente",
          "Error al eliminar notificación": "Error al eliminar notificación",
          "Normal": "Normal",
          "Consulta Legal": "Consulta Legal",
          "Leídas": "Leídas",
          "No Leídas": "No Leídas",
          "Todas": "Todas",
          "Marcar como leída": "Marcar como leída",
          "Abogado": "Abogado",
          "Acciones": "Acciones",
          "Sin asignar": "Sin asignar",
          "Notificaciones Recientes": "Notificaciones Recientes",
          "sin leer": "sin leer",
          "Sin título": "Sin título",
          "Pendiente": "Pendiente",
          "Cancelada": "Cancelada",
          "Reagendada": "Reagendada",
          "Realizada": "Realizada",
          "Sin estado": "Sin estado",
          "Fallido": "Fallido",
          "Realizado": "Realizado",
          "Todos los estados": "Todos los estados",
          "Todos los pagos": "Todos los pagos",
          "Buscar por descripción...": "Buscar por descripción...",
          "Reagendar": "Reagendar",
          "Cancelar": "Cancelar",
          "Aceptar": "Aceptar",
          "Cerrar": "Cerrar",
          "Continuar": "Continuar",
          "Cancelando...": "Cancelando...",
          "Asignando...": "Asignando...",
          "Creando...": "Creando...",
          "Error de validación": "Error de validación",
          "Asignar Abogado": "Asignar Abogado",
          "Documentos": "Documentos",
          // Business Sidebar Menu
          "Principal": "Principal",
          "Dashboard": "Dashboard",
          "Módulos": "Módulos",
          "Lista de Consultas": "Lista de Consultas",
          "Gestionar": "Gestionar",
          "Seguimiento de Casos": "Seguimiento de Casos",
          "Mis Casos": "Mis Casos",
          "Casos USCIS": "Casos USCIS",
          "Casos EOIR/NVC": "Casos EOIR/NVC",
          "Biblioteca de Recursos": "Biblioteca de Recursos",
          "Artículos": "Artículos",
          "Guías": "Guías",
          "Preguntas Frecuentes": "Preguntas Frecuentes",
          "Gestión de Recursos": "Gestión de Recursos",
          "Preparación de Documentos": "Preparación de Documentos",
          "Formularios": "Formularios",
          "Documentos Enviados": "Documentos Enviados",
          "Revisión de Documentos": "Revisión de Documentos",
          "Herramientas & Servicios": "Herramientas & Servicios",
          "Foro Comunitario": "Foro Comunitario",
          "Foro": "Foro",
          "Moderación": "Moderación",
          "Noticias & Información": "Noticias & Información",
          "Search": "Buscar",
          "Podcasts": "Podcasts",
          "Administración": "Administración",
          "Mi Perfil": "Mi Perfil",
          "Editar Perfil": "Editar Perfil",
          "¿Desea cerrar sesión?": "¿Desea cerrar sesión?",
          "Esta acción cerrará tu sesión actual y deberás iniciar sesión nuevamente para acceder al sistema.": "Esta acción cerrará tu sesión actual y deberás iniciar sesión nuevamente para acceder al sistema.",
          "Confirmar": "Confirmar",
          "Nueva Password": "Nueva Contraseña",
          "Confirmar Nueva Password": "Confirmar Nueva Contraseña",
          "Cambiar imagen": "Cambiar imagen",
          "Ingresa tu nueva contraseña": "Ingresa tu nueva contraseña",
          "Confirma tu nueva contraseña": "Confirma tu nueva contraseña",
          "Cambiando...": "Cambiando...",
          "Cambiar Contraseña": "Cambiar Contraseña",
          "Actualizar Perfil": "Actualizar Perfil",
          "Guardando...": "Guardando...",
          // Forgot Password
          "Ingresa tu email y te enviaremos un código de recuperación": "Ingresa tu email y te enviaremos un código de recuperación",
          "ejemplo@email.com": "ejemplo@email.com",
          "Enviando...": "Enviando...",
          "Enviar Código": "Enviar Código",
          "¿Ya tienes una cuenta?": "¿Ya tienes una cuenta?",
          "Por favor ingresa tu email": "Por favor ingresa tu email",
          "Código de recuperación enviado a tu email": "Código de recuperación enviado a tu email",
          "Error al solicitar recuperación de contraseña": "Error al solicitar recuperación de contraseña",
          "Ingresa el código enviado a": "Ingresa el código enviado a",
          "Código de Verificación": "Código de Verificación",
          "¿No recibiste el código?": "¿No recibiste el código?",
          "Reenviando...": "Reenviando...",
          "Verificando...": "Verificando...",
          "Verificar Código": "Verificar Código",
          "Sesión expirada. Por favor solicita un nuevo código": "Sesión expirada. Por favor solicita un nuevo código",
          "Por favor ingresa el código completo": "Por favor ingresa el código completo",
          "Error: ID de recuperación no encontrado": "Error: ID de recuperación no encontrado",
          "Código verificado correctamente": "Código verificado correctamente",
          "Código inválido o expirado": "Código inválido o expirado",
          "Error al verificar el código": "Error al verificar el código",
          "Código reenviado a tu email": "Código reenviado a tu email",
          "Error al reenviar el código": "Error al reenviar el código",
          "Mínimo 8 caracteres": "Mínimo 8 caracteres",
          "Por favor ingresa una contraseña": "Por favor ingresa una contraseña",
          "La contraseña debe tener al menos 8 caracteres": "La contraseña debe tener al menos 8 caracteres",
          "Las contraseñas no coinciden": "Las contraseñas no coinciden",
          "Cambiando contraseña...": "Cambiando contraseña...",
          "Contraseña cambiada exitosamente. Puedes iniciar sesión ahora.": "Contraseña cambiada exitosamente. Puedes iniciar sesión ahora.",
          "Error al cambiar la contraseña": "Error al cambiar la contraseña",
          "ResetYourPassword": "Restablecer Contraseña",
          "EnterOTP": "Ingresar Código",
          "Resend": "Reenviar",
          "CreateYourPassword": "Crear Contraseña",
          "NewPassword": "Nueva Contraseña",
          "RetypePassword": "Confirmar Contraseña",
          "SignIn": "Iniciar Sesión",
          "Tarjetas de Usuario": "Tarjetas de Usuario",
          "Roles y Permisos": "Roles y Permisos",
          "Gestión de Roles": "Gestión de Roles",
          "Gestión de Permisos": "Gestión de Permisos",
          "Nuevo Rol": "Nuevo Rol",
          "Editar Rol": "Editar Rol",
          "Rol eliminado exitosamente": "Rol eliminado exitosamente",
          "Estado del rol actualizado": "Estado del rol actualizado",
          "Rol actualizado exitosamente": "Rol actualizado exitosamente",
          "Rol creado exitosamente": "Rol creado exitosamente",
          "Error al guardar rol": "Error al guardar rol",
          "Gestionar Permisos": "Gestionar Permisos",
          "Buscar permisos...": "Buscar permisos...",
          "Permiso eliminado del rol": "Permiso eliminado del rol",
          "Permiso agregado al rol": "Permiso agregado al rol",
          "Error al actualizar permisos": "Error al actualizar permisos",
          "Quitar": "Quitar",
          "Agregar": "Agregar",
          "permisos": "permisos",
          "Rol Público": "Rol Público",
          "Nuevo Permiso": "Nuevo Permiso",
          "Editar Permiso": "Editar Permiso",
          "Estado del permiso actualizado": "Estado del permiso actualizado",
          "Permiso actualizado exitosamente": "Permiso actualizado exitosamente",
          "Error al guardar permiso": "Error al guardar permiso",
          "La creación de permisos no está disponible desde la interfaz": "La creación de permisos no está disponible desde la interfaz",
          "La creación de permisos debe hacerse desde el backend": "La creación de permisos debe hacerse desde el backend",
          "Confirmar Eliminación": "Confirmar Eliminación",
          "¿Estás seguro de que deseas eliminar este elemento?": "¿Estás seguro de que deseas eliminar este elemento?",
          "Esta acción no se puede deshacer.": "Esta acción no se puede deshacer.",
          "Código": "Código",
          "Países": "Países",
          "Mis Pagos": "Mis Pagos",
          "Historial de Pagos": "Historial de Pagos",
          "Gestión de Pagos": "Gestión de Pagos",
          "Mis Notificaciones": "Mis Notificaciones",
          "Enviar Notificación": "Enviar Notificación",
          "Reportes": "Reportes",
          "Reporte de Consultas": "Reporte de Consultas",
          "Reporte de Documentos": "Reporte de Documentos",
          "Reporte de Casos": "Reporte de Casos",
          "Analítica General": "Analítica General",
          "Configuración": "Configuración",
          "Cerrar Sesión": "Cerrar Sesión",
          "Configuración General": "Configuración General",
          "Políticas y Privacidad": "Políticas y Privacidad",
          "Actualizaciones de App": "Actualizaciones de App",
          "Historial de Acceso": "Historial de Acceso",
          "Versiones APK": "Versiones APK",
          "Gestión de Versiones APK": "Gestión de Versiones APK",
          "Crear Nueva Versión": "Crear Nueva Versión",
          "Editar Versión": "Editar Versión",
          "Versión": "Versión",
          "URL": "URL",
          "Descripción": "Descripción",
          "Fecha de Creación": "Fecha de Creación",
          "Buscar por versión...": "Buscar por versión...",
          "No se encontraron versiones": "No se encontraron versiones",
          "Error al cargar versiones": "Error al cargar versiones",
          "Versión eliminada exitosamente": "Versión eliminada exitosamente",
          "Error al eliminar versión": "Error al eliminar versión",
          "Estado de la versión actualizado": "Estado de la versión actualizado",
          "Error al cambiar estado": "Error al cambiar estado",
          "La versión es requerida": "La versión es requerida",
          "La URL es requerida": "La URL es requerida",
          "La URL no tiene un formato válido": "La URL no tiene un formato válido",
          "Versión actualizada exitosamente": "Versión actualizada exitosamente",
          "Versión creada exitosamente": "Versión creada exitosamente",
          "Error al guardar versión": "Error al guardar versión",
          "Ejemplo: 1.0.0": "Ejemplo: 1.0.0",
          "Formato recomendado: número.número.número (ej: 1.0.0)": "Formato recomendado: número.número.número (ej: 1.0.0)",
          "URL completa donde se encuentra el archivo APK": "URL completa donde se encuentra el archivo APK",
          "Descripción de los cambios en esta versión...": "Descripción de los cambios en esta versión...",
          "Opcional: Descripción de los cambios o mejoras en esta versión": "Opcional: Descripción de los cambios o mejoras en esta versión",
          "¿Estás seguro de que deseas eliminar la versión": "¿Estás seguro de que deseas eliminar la versión",
          // Access History
          "Buscar por usuario...": "Buscar por usuario...",
          "No se encontraron registros de acceso": "No se encontraron registros de acceso",
          "Fecha de Acceso": "Fecha de Acceso",
          "Exitoso": "Exitoso",
          "IP": "IP",
          "Página": "Página",
          "de": "de",
          "Anterior": "Anterior",
          "Siguiente": "Siguiente",
          "Error al cargar historial de acceso": "Error al cargar historial de acceso",
          // Case Follow-Up
          "Casos Activos": "Casos Activos",
          "Todos los Casos": "Todos los Casos",
          "Casos con Relaciones": "Casos con Relaciones",
          "Casos de Abogados": "Casos de Abogados",
          "Casos de Clientes": "Casos de Clientes",
          "Crear Alias": "Crear Alias",
          "Consultar USCIS": "Consultar USCIS",
          "Agregar Nota": "Agregar Nota",
          "Número de Caso USCIS": "Número de Caso USCIS",
          "Tipo de Caso": "Tipo de Caso",
          "USCIS": "USCIS",
          "EOIR": "EOIR",
          "CEAC": "CEAC",
          "Alias/Nombre": "Alias/Nombre",
          "Estado Actual": "Estado Actual",
          "Última Actualización": "Última Actualización",
          "Historial de Casos": "Historial de Casos",
          "Comentario": "Comentario",
          "Respuesta USCIS": "Respuesta USCIS",
          "Ver Detalle": "Ver Detalle",
          "No se encontraron casos": "No se encontraron casos",
          "Error al cargar casos": "Error al cargar casos",
          "Alias creado exitosamente": "Alias creado exitosamente",
          "Error al crear alias": "Error al crear alias",
          "Caso consultado exitosamente": "Caso consultado exitosamente",
          "Error al consultar caso": "Error al consultar caso",
          "Nota agregada exitosamente": "Nota agregada exitosamente",
          "Error al agregar nota": "Error al agregar nota",
          "El nombre es requerido": "El nombre es requerido",
          "El número de caso USCIS es requerido": "El número de caso USCIS es requerido",
          "El tipo de caso es requerido": "El tipo de caso es requerido",
          "El comentario es requerido": "El comentario es requerido",
          "Sugerencias": "Sugerencias",
          "Seleccionar historial": "Seleccionar historial",
          "Información del Caso": "Información del Caso",
          "Relaciones": "Relaciones",
          "Sin historial disponible": "Sin historial disponible",
          "Consultando...": "Consultando...",
          "Agregando...": "Agregando...",
          "resultados": "resultados",
          "Todos los tipos": "Todos los tipos",
          "Ingrese un nombre o alias para el caso": "Ingrese un nombre o alias para el caso",
          "Resultado de la Consulta": "Resultado de la Consulta",
          "Guardar Resultado": "Guardar Resultado",
          "Consultar": "Consultar",
          "Seleccione un historial de caso": "Seleccione un historial de caso",
          "El comentario debe tener al menos 10 caracteres": "El comentario debe tener al menos 10 caracteres",
          "No hay historiales de caso disponibles para agregar notas": "No hay historiales de caso disponibles para agregar notas",
          "Ingrese un comentario sobre el caso...": "Ingrese un comentario sobre el caso...",
          "Mínimo 10 caracteres": "Mínimo 10 caracteres",
          "Caso no encontrado": "Caso no encontrado",
          "Volver a la lista": "Volver a la lista",
          "Volver": "Volver",
          "Alien Number EOIR": "Alien Number EOIR",
          "Información de relaciones disponible en la vista completa": "Información de relaciones disponible en la vista completa",
          "Todos": "Todos",
          "Por Abogado": "Por Abogado",
          "Por Cliente": "Por Cliente",
        },
      },
      fr: {
        translations: {
          "General": "Général",
          "Dashboards": "Tableaux de bord",
          "Default": "Défaut",
          "Project": "Projet",
          "Online Course":"Cours en ligne",
          "Ecommerce": "Commerce électronique",
          "Education": "Éducation",
          "Widgets": "Widgets",
          "Chart": "Graphique",
          "Applications": "Applications",
          "Project List": "Liste de projets",
          "Create New": "Créer un nouveau",
          "File Manager": "Gestionnaire de fichiers",
          "Add Product": "Ajouter un produit",
          "Product": "Produit",
          "Product Page": "Page de produit",
          "Product List": "Liste de produits",
          "Payment Details": "Détails de paiement",
          "Order History": "Historique des commandes",
          "Invoice": "Facture",
          "Invoice-1": "Facture-1",
          "Invoice-2": "Facture-2",
          "Invoice-3": "Facture-3",
          "Invoice-4": "Facture-4",
          "Invoice-5": "Facture-5",
          "Invoice-6": "Facture-6",
          "Cart": "Panier",
          "Wishlist": "Liste de souhaits",
          "Checkout": "Paiement",
          "Pricing": "Tarification",
          "Chat": "Discussion",
          "Users": "Utilisateurs",
          "Letter Box": "Boîte aux lettres",
          "Private Chat": "Discussion privée",
          "Group Chat": "Discussion de groupe",
          "User Profile": "Profil de l'utilisateur",
          "User Edit": "Modifier l'utilisateur",
          "User Cards": "Cartes d'utilisateur",
          "Bookmarks": "Signets",
          "Contacts": "Contacts",
          "Task": "Tâche",
          "Calendar": "Calendrier",
          "Social App": "Application sociale",
          "Todo": "À faire",
          "Search Result": "Résultat de la recherche",
          "Form Validation": "Validation de formulaire",
          "Base Inputs": "Entrées de base",
          "Checkbox & Radio": "Cases à cocher et boutons radio",
          "Input Groups": "Groupes d'entrée",
          "Input Mask": "Masque de saisie",
          "Mega Option": "Option méga",
          "Datepicker": "Sélecteur de date",
          "Touchspin": "Touchspin",
          "Switch": "Interrupteur",
          "Forms": "Formulaires",
          "Form Controls": "Contrôles de formulaire",
          "Forms & Table": "Formulaires et table",
          "Typeahead": "Suggestion de texte",
          "Clipboard": "Presse-papiers",
          "Form Widget": "Widget de formulaire",
          "Form Wizard 1": "Assistant de formulaire 1",
          "Form Wizard 2": "Assistant de formulaire 2",
          "Two Factor": "Double authentification",
          "Form Layout": "Mise en page du formulaire",
          "Table": "Tableau",
          "Reactstrap Tables": "Tableaux Reactstrap",
          "Basic Tables": "Tables de base",
          "Table Components": "Composants de tableau",
          "Data Tables": "Tableaux de données",
          "Basic Init": "Initialisation de base",
          "Advance Init": "Initialisation avancée",
          "API": "API",
          "Data Source": "Source de données",
          "Components": "Composants",
          "Typography": "Typographie",
          "Avatars": "Avatars",
          "Helper Classes": "Classes d'aide",
          "Grid": "Grille",
          "Tag & Pills": "Étiquettes et pastilles",
          "Progress": "Progression",
          "Modal": "Fenêtre modale",
          "Alert": "Alerte",
          "Popover": "Infobulle",
          "Tooltip": "Info-bulle",
          "Dropdown": "Menu déroulant",
          "Accordion": "Accordéon",
          "Tabs": "Onglets",
          "Lists": "Listes",
          "Bonus-Ui": "Bonus-UI",
          "Scrollable": "Déroulant",
          "Tree View": "Vue arborescente",
          "Toasts": "Notifications",
          "Rating": "Évaluation",
          "Dropzone": "Zone de dépôt",
          "Tour": "Visite guidée",
          "SweetAlert2": "SweetAlert2",
          "Carousel": "Carrousel",
          "Ribbons": "Rubans",
          "Pagination": "Pagination",
          "Breadcrumb": "Fil d'Ariane",
          "Range Slider": "Curseur de plage",
          "Image Cropper": "Recadrage d'image",
          "Basic Card": "Carte de base",
          "Creative Card": "Carte créative",
          "Timeline": "Chronologie",
          "Icons": "Icônes",
          "Flag Icon": "Icône de drapeau",
          "Fontawesome Icon": "Icône Fontawesome",
          "Ico Icon": "Icône Ico",
          "Themify Icon": "Icône Themify",
          "Feather Icon": "Icône Feather",
          "Weather Icon": "Icône météo",
          "Buttons": "Boutons",
          "Default Style": "Style par défaut",
          "Flat Style": "Style plat",
          "Edge Style": "Style en relief",
          "Raised Style": "Style en relief",
          "Button Group": "Groupe de boutons",
          "Charts": "Graphiques",
          "Apex Chart": "Graphique Apex",
          "Google Chart": "Graphique Google",
          "Chart JS Chart": "Graphique Chart JS",
          "Pages": "Pages",
          "Sample Page": "Page d'exemple",
          "Others": "Autres",
          "Error Pages": "Pages d'erreur",
          "Error 400": "Erreur 400",
          "Error 401": "Erreur 401",
          "Error 403": "Erreur 403",
          "Error 404": "Erreur 404",
          "Error 500": "Erreur 500",
          "Error 503": "Erreur 503",
          "Login Simple": "Connexion simple",
          "Login with Bg Image": "Connexion avec image de fond",
          "Login With Image Two": "Connexion avec deux images",
          "Login With Validation": "Connexion avec validation",
          "Login With Tooltip": "Connexion avec info-bulle",
          "Login With Sweetalert": "Connexion avec SweetAlert",
          "Register Simple": "Inscription simple",
          "Register With Bg Image": "Inscription avec image de fond",
          "Register With Bg Two": "Inscription avec deux images de fond",
          "Register Wizard": "Assistant d'inscription",
          "Unlock User": "Déverrouiller l'utilisateur",
          "Forget Password": "Mot de passe oublié",
          "Reset Password": "Réinitialiser le mot de passe",
          "Maintenance": "Maintenance",
          "Coming Simple": "Bientôt disponible (version simple)",
          "Coming With Bg Video": "Bientôt disponible avec vidéo de fond",
          "Coming With Bg Image": "Bientôt disponible avec image de fond",
          "Miscellaneous": "Divers",
          "Gallery": "Galerie",
          "Gallery Grids": "Grilles de galerie",
          "Gallery Grid Desc": "Description de la grille de galerie",
          "Masonry Gallery": "Galerie en maçonnerie",
          "Masonry With Desc": "Maçonnerie avec description",
          "Hover Effect": "Effet de survol",
          "Blog": "Blog",
          "Blog Details": "Détails du blog",
          "Blog Single": "Article de blog unique",
          "Add Post": "Ajouter un article",
          "FAQ": "FAQ",
          "Job Search": "Recherche d'emploi",
          "Cards View": "Vue en cartes",
          "List View": "Vue en liste",
          "Job Detail": "Détails de l'emploi",
          "Apply": "Postuler",
          "Learning": "Apprentissage",
          "Learning List": "Liste d'apprentissage",
          "Detailed Course": "Cours détaillé",
          "Map": "Carte",
          "Google Map": "Carte Google",
          "Leaflet Map": "Carte Leaflet",
          "Editor": "Éditeur",
          "CK Editor": "Éditeur CK",
          "MDE Editor": "Éditeur MDE",
          "ACE Editor": "Éditeur ACE",
          "Knowledgebase": "Base de connaissances",
          "Ui-Kits": "Kits d'interface utilisateur.",
          "SupportTicket": "Ticket de support",
          "Authentication": "Authentification",
          "Login With Bg Image": "Connexion avec Image de Fond",
          "Pinned": "Épinglé",
          "Coming Soon": "Prochainement",
        },
      },
      pt: {
        translations: {
          "General": "Geral",
          "Dashboards": "Painéis",
          "Default": "Padrão",
          "Project": "Projeto",
          "Online Course":"Curso online",
          "Ecommerce": "Comércio Eletrônico",
          "Education": "Educação",
          "Widgets": "Widgets",
          "Chart": "Gráfico",
          "Applications": "Aplicativos",
          "Project List": "Lista de Projetos",
          "Create New": "Criar Novo",
          "File Manager": "Gerenciador de Arquivos",
          "Add Product": "Adicionar Produto",
          "Product": "Produto",
          "Product Page": "Página do Produto",
          "Product List": "Lista de Produtos",
          "Payment Details": "Detalhes do Pagamento",
          "Order History": "Histórico de Pedidos",
          "Invoice": "Fatura",
          "Invoice-1": "Fatura-1",
          "Invoice-2": "Fatura-2",
          "Invoice-3": "Fatura-3",
          "Invoice-4": "Fatura-4",
          "Invoice-5": "Fatura-5",
          "Invoice-6": "Fatura-6",
          "Cart": "Carrinho",
          "Wishlist": "Lista de Desejos",
          "Checkout": "Finalizar Compra",
          "Pricing": "Preços",
          "Chat": "Chat",
          "Users": "Usuários",
          "Letter Box": "Caixa de Correio",
          "Private Chat": "Chat Privado",
          "Group Chat": "Chat em Grupo",
          "User Profile": "Perfil do Usuário",
          "User Edit": "Editar Usuário",
          "User Cards": "Cartões de Usuário",
          "Bookmarks": "Marcadores",
          "Contacts": "Contatos",
          "Task": "Tarefa",
          "Calendar": "Calendário",
          "Social App": "Aplicativo Social",
          "Todo": "Lista de Tarefas",
          "Search Result": "Resultado da Pesquisa",
          "Form Validation": "Validação de Formulário",
          "Base Inputs": "Entradas Básicas",
          "Checkbox & Radio": "Caixas de Seleção e Rádio",
          "Input Groups": "Grupos de Entrada",
          "Input Mask": "Máscara de Entrada",
          "Mega Option": "Opção Mega",
          "Datepicker": "Seletor de Data",
          "Touchspin": "Touchspin",
          "Switch": "Interruptor",
          "Forms": "Formulários",
          "Form Controls": "Controles de Formulário",
          "Forms & Table": "Formulários e Tabela",
          "Typeahead": "Sugestão de Texto",
          "Clipboard": "Área de Transferência",
          "Form Widget": "Widget de Formulário",
          "Form Wizard 1": "Assistente de Formulário 1",
          "Form Wizard 2": "Assistente de Formulário 2",
          "Two Factor": "Autenticação em Dois Passos",
          "Form Layout": "Layout do Formulário",
          "Table": "Tabela",
          "Reactstrap Tables": "Tabelas Reactstrap",
          "Basic Tables": "Tabelas Básicas",
          "Table Components": "Componentes de Tabela",
          "Data Tables": "Tabelas de Dados",
          "Basic Init": "Inicialização Básica",
          "Advance Init": "Inicialização Avançada",
          "API": "API",
          "Data Source": "Fonte de Dados",
          "Components": "Componentes",
          "Typography": "Tipografia",
          "Avatars": "Avatares",
          "Helper Classes": "Classes de Ajuda",
          "Grid": "Grade",
          "Tag & Pills": "Etiqueta e Abas",
          "Progress": "Progresso",
          "Modal": "Modal",
          "Alert": "Alerta",
          "Popover": "Popover",
          "Tooltip": "Dica de Ferramenta",
          "Dropdown": "Menu Suspenso",
          "Accordion": "Acordeão",
          "Tabs": "Abas",
          "Lists": "Listas",
          "Bonus-Ui": "UI Extra",
          "Scrollable": "Rolável",
          "Tree View": "Visualização de Árvore",
          "Toasts": "Notificações",
          "Rating": "Avaliação",
          "Dropzone": "Zona de Soltar",
          "Tour": "Tour",
          "SweetAlert2": "SweetAlert2",
          "Carousel": "Carrossel",
          "Ribbons": "Fitas",
          "Pagination": "Paginação",
          "Breadcrumb": "Migalha de Pão",
          "Range Slider": "Controle de Faixa",
          "Image Cropper": "Cortador de Imagem",
          "Basic Card": "Cartão Básico",
          "Creative Card": "Cartão Criativo",
          "Timeline": "Linha do Tempo",
          "Icons": "Ícones",
          "Flag Icon": "Ícone de Bandeira",
          "Fontawesome Icon": "Ícone Fontawesome",
          "Ico Icon": "Ícone Ico",
          "Themify Icon": "Ícone Themify",
          "Feather Icon": "Ícone Feather",
          "Weather Icon": "Ícone de Clima",
          "Buttons": "Botões",
          "Default Style": "Estilo Padrão",
          "Flat Style": "Estilo Plano",
          "Edge Style": "Estilo em Destaque",
          "Raised Style": "Estilo em Relevo",
          "Button Group": "Grupo de Botões",
          "Charts": "Gráficos",
          "Apex Chart": "Gráfico Apex",
          "Google Chart": "Gráfico do Google",
          "Chart JS Chart": "Gráfico Chart JS",
          "Pages": "Páginas",
          "Sample Page": "Página de Exemplo",
          "Others": "Outros",
          "Error Pages": "Páginas de Erro",
          "Error 400": "Erro 400",
          "Error 401": "Erro 401",
          "Error 403": "Erro 403",
          "Error 404": "Erro 404",
          "Error 500": "Erro 500",
          "Error 503": "Erro 503",
          "Login Simple": "Login Simples",
          "Login with Bg Image": "Login com Imagem de Fundo",
          "Login With Image Two": "Login com Duas Imagens",
          "Login With Validation": "Login com Validação",
          "Login With Tooltip": "Login com Dica de Ferramenta",
          "Login With Sweetalert": "Login com SweetAlert",
          "Register Simple": "Registro Simples",
          "Register With Bg Image": "Registro com Imagem de Fundo",
          "Register With Bg Two": "Registro com Duas Imagens de Fundo",
          "Register Wizard": "Assistente de Registro",
          "Unlock User": "Desbloquear Usuário",
          "Forget Password": "Esqueci a Senha",
          "Reset Password": "Redefinir Senha",
          "Maintenance": "Manutenção",
          "Coming Simple": "Em Breve - Simples",
          "Coming With Bg Video": "Em Breve com Vídeo de Fundo",
          "Coming With Bg Image": "Em Breve com Imagem de Fundo",
          "Miscellaneous": "Diversos",
          "Gallery": "Galeria",
          "Gallery Grids": "Grade de Galeria",
          "Gallery Grid Desc": "Descrição da Grade de Galeria",
          "Masonry Gallery": "Galeria em Alvenaria",
          "Masonry With Desc": "Alvenaria com Descrição",
          "Hover Effect": "Efeito de Passagem",
          "Blog": "Blog",
          "Blog Details": "Detalhes do Blog",
          "Blog Single": "Postagem de Blog Única",
          "Add Post": "Adicionar Postagem",
          "FAQ": "Perguntas Frequentes",
          "Job Search": "Busca de Empregos",
          "Cards View": "Visualização em Cartões",
          "List View": "Visualização em Lista",
          "Job Detail": "Detalhe do Emprego",
          "Apply": "Aplicar",
          "Learning": "Aprendizado",
          "Learning List": "Lista de Aprendizado",
          "Detailed Course": "Curso Detalhado",
          "Map": "Mapa",
          "Google Map": "Mapa do Google",
          "Leaflet Map": "Mapa Leaflet",
          "Editor": "Editor",
          "CK Editor": "Editor CK",
          "MDE Editor": "Editor MDE",
          "ACE Editor": "Editor ACE",
          "Knowledgebase": "Base de Conhecimento",
          "Ui-Kits": "Kits de Interface de Usuário.",
          "SupportTicket": "Ticket de Suporte",
          "Authentication": "Autenticação",
          "Login With Bg Image": "Login com Imagem de Fundo",
          "Pinned": "Fixado",
          "Coming Soon": "Em Breve",
        },
      },
    },
    fallbackLng: "es",
    debug: false,

    // have a common namespace used around the full app
    ns: ["translations"],
    defaultNS: "translations",

    keySeparator: false, // we use content as keys

    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
